module.exports = __webpack_public_path__ + "static/media/75.0d762109.jpg";